import { render } from "./RelationshipTypeCard.vue?vue&type=template&id=3b673df9&scoped=true"
import script from "./RelationshipTypeCard.vue?vue&type=script&lang=js"
export * from "./RelationshipTypeCard.vue?vue&type=script&lang=js"

import "./RelationshipTypeCard.vue?vue&type=style&index=0&id=3b673df9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b673df9"]])

export default __exports__